var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"back-component"}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',{attrs:{"color":"white"},on:{"click":function($event){return _vm.navigateBack()}}},[_vm._v("mdi-keyboard-backspace")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }